/**
 * Client-side check for freemium/trialing branch child limit (≤10).
 * Use before calling create-child-and-invite-parent or bulk-import-children
 * to avoid a round-trip when the limit would be exceeded.
 * Server still enforces the limit.
 *
 * License handling:
 * - trialing / freemium (and not permanent free): limit 10 children
 * - permanent free: no limit
 * - active (paid): no limit
 * - other (cancelled, expired): no limit here (handled elsewhere)
 */

export const FREEMIUM_LIMIT_MESSAGE =
  'Darmowa licencja Freemium pozwala jedynie na dołączenie 10 podopiecznych. Zapraszamy do skonfigurowania płatności';

/**
 * @param {object} branch - Branch row with subscription_status, is_permanent_free
 * @param {number} currentChildCount - Current number of children in the branch
 * @param {number} addCount - Number of children to add (1 for single add, rows.length for bulk)
 * @returns {{ allowed: boolean, message?: string }}
 */
export function wouldExceedFreemiumLimit(branch, currentChildCount, addCount) {
  if (!branch) return { allowed: true };
  if (branch.is_permanent_free === true) return { allowed: true };
  const status = branch.subscription_status;
  if (status !== 'freemium' && status !== 'trialing') return { allowed: true };
  const afterCount = (currentChildCount ?? 0) + addCount;
  if (afterCount <= 10) return { allowed: true };
  return { allowed: false, message: FREEMIUM_LIMIT_MESSAGE };
}
